import React from "react"
import Helmet from "react-helmet"
const HelmetJsonLD = ({children}:{children:object}) => <Helmet><script type="application/ld+json" defer={false}>{JSON.stringify(children)}</script></Helmet>

export default HelmetJsonLD